import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEORDERS } from "../../../../utils/constants";
import documentTemplateService from "../../../../services/general/documentTemplateService";

const usePOSchema = () =>
  useQuery<string[], Error>({
    queryKey: [`${CACHE_KEY_PURCHASEORDERS}Schema`],
    queryFn: () => documentTemplateService.GetPOSchema(),
    initialData: [],
  });

export default usePOSchema;
